import countries from "./allCountries.json";
//import countriesStates from "./allCountryStates.json";
//import statesCounties from "./allStateCounty.json";
import usAllStates from "./allUSStates.json";
import usAllCounty from "./allUSCounty.json";

const countryId = 6252001;

export function getGeoStateData(geonameId) {
  const data = usAllStates.filter(x => x.countryGeonameId == geonameId);
  return data;
}

export async function getGeoCountyData(geonameId) {
  const data = usAllCounty.filter(x => x.stateGeonameId == geonameId);
  return data;
}

export async function getGeoCityData(geonameId) {
  const data = usAllCounty.filter(x => x.stateGeonameId == geonameId);
  return data;
}

export function getStateList() {
  return getGeoStateData(countryId);
}

export function getAllCountries() {
  let us = countries.filter(x => x.geonameId === countryId);
  let updCountries = [...countries];
  if (us.length > 0) {
    updCountries.splice(0, 0, us[0]);
  }
  return updCountries;
}

export default {
  getGeoStateData,
  getGeoCountyData,
  getGeoCityData,
  getStateList,
  getAllCountries,
};
